import { useState } from "react"
import axios from "axios";

import { Spin, Modal } from "antd";
import createImagePromptGPT from "./controller/createImagePromptGPT";

const backend = process.env.REACT_APP_BACKEND;

function CreateBackgroundPrompt({ record, prompt, gptModel, dataChangeHandler }) {
  const [loading, setLoading] = useState(false)

  const createBackgroundPrompt = (e) => {
    e.stopPropagation();
    if(!record.translate_text) return

    const backgroundPrompt = prompt.backgroundPrompt.replace(/{}|{ }/gi,record.word)
    setLoading(true)
    createImagePromptGPT(backgroundPrompt, gptModel.gpt_model)
    .then(newPrompt=>{
      let onlyPrompt = newPrompt
      if(newPrompt[0] === `"`) {
        onlyPrompt = newPrompt.slice(1,-1)
      }
      const value = {
        id: record.dalle_id,
        WordExMaster_id: record.id,
        background_prompt: onlyPrompt
      }
      axios.post(`${backend}/contents/new_word/image/background_prompt`,{value})
      .then(res=>{
        const instance = {...record}
        instance.background_prompt = onlyPrompt
        instance.dalle_id = res.data.data
        dataChangeHandler(instance, "background_prompt")
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"서버 에러가 발생해서 프롬프트를 생성하지 못했습니다."
        })
      })
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title:"에러",
        okText:"확인",
        content:"AI 에러가 발생해서 프롬프트를 생성하지 못했습니다."
      })
    })
    .finally(()=>{
      setLoading(false)
    })
  }
  const deleteBackgroundPrompt = (e) => {
    e.stopPropagation();
    if(record.background_prompt) {
      setLoading(true)
      axios.delete(`${backend}/contents/new_word/image/background_prompt/${record.id}`)
      .then(res=>{
        const instance = {...record}
        instance.background_prompt = null
        dataChangeHandler(instance, "background_prompt")
      })
      .catch(err=>{
        console.log(err)
      })
      .finally(()=>[
        setLoading(false)
      ])
    }
  }

  return (
    <div>
      <Spin spinning={loading}>
        <a style={{ margin: "0px 5px", whiteSpace: "pre" }} disabled={!record.translate_text} onClick={(e) => createBackgroundPrompt(e)}>생성</a>
        <a style={{ margin: "0px 5px", whiteSpace: "pre" }} disabled={!record.background_prompt} onClick={(e) => deleteBackgroundPrompt(e)}>삭제</a>
      </Spin>
    </div>
  )
}

export default CreateBackgroundPrompt